import { h, Fragment } from 'preact';

type CustomInputProps = {
  name: string;
  value: string;
};

const CustomInputHidden = (props: CustomInputProps) => {
  return (
    <input
      type="hidden"
      class="form-control input"
      id={props.name}
      name={props.name}
      value={props.value}
    />
  );
};

export default CustomInputHidden;
